module.exports = __webpack_public_path__ + "common/components/IconDS22/f9bb54b39be6ebb133fc333cc7f02c11.svg";